import { createAsyncTypes } from 'utils/ActionCreator'

export const GET_NOTIFICATIONS_ASYNC = createAsyncTypes(
  'GET_ASYNC',
  'Settings/CustomizationO365/GET_NOTIFICATIONS_ASYNC'
)
export const UPDATE_NOTIFICATIONS_ASYNC = createAsyncTypes(
  'UPDATE_NOTIFICATIONS_ASYNC',
  'Settings/CustomizationO365/UPDATE_NOTIFICATIONS_ASYNC'
)
export const RESTORE_NOTIFICATIONS_ASYNC = createAsyncTypes(
  'RESTORE_ASYNC',
  'Settings/CustomizationO365/RESTORE_NOTIFICATIONS_ASYNC'
)
